<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Ticket</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Destination Information - (Step 2 of 3)
    </ion-list-header>

    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onNextClick(f)" #f="ngForm" novalidate>

            <ion-radio-group value="dropoff" name="radioGroup" [(ngModel)]="radioGroupValue" data-test="directionGroup">
                <ion-item>
                    <ion-label class="ion-text-wrap ion-no-padding">
                        <span class="line1">Dropoff Ticket.</span><br />
                        <span class="line2">Driving from the dealership and dropping off.</span><br />
                    </ion-label>
                    <ion-radio slot="start" value="dropoff" name="dropoff" data-test="dropoff"
                        (click)="onToggleDirectionClick('dropoff')">
                    </ion-radio>
                </ion-item>

                <ion-item>
                    <ion-label class="ion-text-wrap ion-no-padding">
                        <span class="line1">Pickup Ticket.</span><br />
                        <span class="line2">Picking up and driving back to the dealership.</span><br />
                    </ion-label>
                    <ion-radio slot="start" value="pickup" name="pickup" data-test="pickup"
                        (click)="onToggleDirectionClick('pickup')">
                    </ion-radio>
                </ion-item>
            </ion-radio-group>

            <div data-test="locationAddress">
                @if (vm.ticket.fromDealership) {
                <div id="dropoff">
                    <ion-item id="dropoffLocationName">
                        <ion-label class="ion-text-wrap" position="stacked">Dropoff Location Name</ion-label>
                        <ion-input type="text" [(ngModel)]="vm.ticket.dropoff.locationName"
                            placeholder="Work, Home, Starbucks, na" name="dropoffLocation" required
                            #dropoffLocation="ngModel" data-test="dropoffLocation"
                            [ngClass]="{ 'is-invalid': f.submitted && dropoffLocation.invalid }">
                        </ion-input>
                        @if (submitted && dropoffLocation.invalid) {
                        <div>
                            <div class="validationErrorMsg">Dropoff Location Name is required.</div>
                        </div>
                        }
                    </ion-item>

                    <ion-item>
                        <ion-label class="ion-text-wrap" position="stacked">Dropoff Street Address</ion-label>
                        <ion-input id="dropoffStreetAddress" type="text"
                            [(ngModel)]="vm.ticket.dropoff.address.streetAddress" placeholder="Example: 123 Main St."
                            name="dropoffStreetAddress"
                            #dropoffStreetAddress="ngModel" required data-test="dropoffStreetAddress"
                            (ionChange)="onStreetAddressChange()"
                            [ngClass]="{ 'is-invalid': f.submitted && dropoffStreetAddress.invalid }">
                        </ion-input>
                        @if (submitted && dropoffStreetAddress.invalid) {
                        <div>
                            <div class="validationErrorMsg">Dropoff Street Address is required.</div>
                        </div>
                        }
                    </ion-item>

                    <ion-item>
                        <ion-label class="ion-text-wrap" position="stacked">Dropoff Zipcode</ion-label>
                        <ion-input id="dropoffZipcode" color="primary" type="number" name="dropoffZipcode"
                            [(ngModel)]="vm.ticket.dropoff.address.zipcode" required #dropoffZipcode="ngModel"
                            data-test="dropoffZipcode"
                            [ngClass]="{ 'is-invalid': f.submitted && dropoffZipcode.invalid }"
                            (ionChange)="onZipcodeChange()">
                        </ion-input>

                        <ion-buttons class="itemButtons" slot="end">
                            <ion-button class="itemButton" color="primary" expand="full" fill="solid"
                                id="dropoffZipcodeButton" (click)="openZipcodePromptClick()" name="search"
                                data-test="dropoffZipcodePromptButton">
                                <ion-icon name="search"></ion-icon>
                            </ion-button>
                        </ion-buttons>
                        @if (submitted && dropoffZipcode.invalid) {
                        <div>
                            <div class="validationErrorMsg">Dropoff Zipcode is required.</div>
                        </div>
                        }
                    </ion-item>

                    <ion-item>
                        <ion-label class="ion-text-wrap" position="stacked">Dropoff City</ion-label>
                        <ion-input id="dropoffCity" color="primary" type="text" name="dropoffCity"
                            [(ngModel)]="vm.ticket.dropoff.address.city" required #dropoffCity="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && dropoffCity.invalid }" readonly
                            data-test="dropoffCity">
                        </ion-input>
                        @if (submitted && dropoffCity.invalid) {
                        <div>
                            <div class="validationErrorMsg">Dropoff City is required.</div>
                        </div>
                        }
                    </ion-item>
                </div>
                }

                @if (!vm.ticket.fromDealership) {
                <div id="pickup">
                    <ion-item id="pickupLocationName">
                        <ion-label class="ion-text-wrap" position="stacked">Pickup Location</ion-label>
                        <ion-input type="text" [(ngModel)]="vm.ticket.pickup.locationName"
                            placeholder="Example: Work, Home, Starbucks, Other, etc." name="pickupLocation"
                            #pickupLocation="ngModel" required
                            [ngClass]="{ 'is-invalid': f.submitted && pickupLocation.invalid }"
                            data-test="pickupLocation">
                        </ion-input>
                        @if (submitted && pickupLocation.invalid) {
                        <div>
                            <div class="validationErrorMsg">Pickup Location is required.</div>
                        </div>
                        }
                    </ion-item>

                    <ion-item>
                        <ion-label class="ion-text-wrap" position="stacked">Pickup Street Address</ion-label>
                        <ion-input id="pickupStreetAddress" type="text"
                            [(ngModel)]="vm.ticket.pickup.address.streetAddress" placeholder="Example: 123 Main St."
                            name="pickupStreetAddress"
                            #pickupStreetAddress="ngModel" required
                            [ngClass]="{ 'is-invalid': f.submitted && pickupStreetAddress.invalid }"
                            data-test="pickupStreetAddress" (ionChange)="onStreetAddressChange()">
                        </ion-input>
                        @if (submitted && pickupStreetAddress.invalid) {
                        <div>
                            <div class="validationErrorMsg">Pickup Street Address is required.</div>
                        </div>
                        }
                    </ion-item>
                    <ion-item>
                        <ion-label class="ion-text-wrap" position="stacked">Pickup Zipcode</ion-label>
                        <ion-input id="pickupZipcode" color="primary" type="number" name="pickupZipcode"
                            [(ngModel)]="vm.ticket.pickup.address.zipcode" required #pickupZipcode="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && pickupZipcode.invalid }" data-test="pickupZipcode"
                            (ionChange)="onZipcodeChange()">
                        </ion-input>

                        <ion-buttons class="itemButtons" slot="end">
                            <ion-button class="itemButton" color="primary" expand="full" fill="solid"
                                id="pickupZipcodeButton" (click)="openZipcodePromptClick()" name="search"
                                data-test="pickupZipcodePromptButton">
                                <ion-icon name="search"></ion-icon>
                            </ion-button>
                        </ion-buttons>
                        @if (submitted && pickupZipcode.invalid) {
                        <div>
                            <div class="validationErrorMsg">Pickup Zipcode is required.</div>
                        </div>
                        }
                    </ion-item>

                    <ion-item>
                        <ion-label class="ion-text-wrap" position="stacked">Pickup City</ion-label>
                        <ion-input id="pickupCity" color="primary" type="text" name="pickupCity"
                            [(ngModel)]="vm.ticket.pickup.address" required #pickupCity="ngModel"
                            [ngClass]="{ 'is-invalid': f.submitted && pickupCity.invalid }" readonly
                            data-test="pickupCity">
                        </ion-input>
                        @if (submitted && pickupCity.invalid) {
                        <div>
                            <div class="validationErrorMsg">Pickup City is required.</div>
                        </div>
                        }
                    </ion-item>
                </div>
                }
            </div>
        </form>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]="!isAddressVerified()" title="Next" (click)="onNextClick(f)" data-test="ticketNext2">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

<ion-footer>
    <ion-toolbar data-test="validateButton">
        @if (vm.ticket.fromDealership) {
        <div id="dropoff">
            <!-- class="addressButton ion-padding"  -->
            <ion-button color="primary" [disabled]=vb.disabled id="dropoffValidateButton" expand="full"
                (click)="onVerifyDropoffAddressClick(f)" data-test="verifyDropoffAddress">
                Verify Dropoff Address
            </ion-button>
        </div>
        }

        @if (!vm.ticket.fromDealership) {
        <div id="pickup">
            <!-- class="addressButton ion-padding"  -->
            <ion-button color="primary" [disabled]=vb.disabled id="pickupValidateButton" expand="full"
                (click)="onVerifyPickupAddressClick(f)" data-test="verifyPickupAddress">
                Verify Pickup Address
            </ion-button>
        </div>
        }
    </ion-toolbar>
</ion-footer>